import { Box, TextField } from '@mui/material';
import { useState } from 'react';
import { PageHeader } from '@/components/ui/PageHeader.tsx';
import { useListCollaborations } from '@/lib/api/collaborations.ts';
import { useGetMe } from '@/lib/api/me.ts';
import { hasUserSigned, bothHaveSigned } from '@/features/collaborations/list/helpers.ts';
import { MyPsiCollaborations } from '@/features/collaborations/list/MyPsiCollaborations.tsx';
import { CollaborationContractModal } from '@/features/collaborations/CollaborationContractModal.tsx';

const PsisPage = () => {
  const [selectedCollabId, setSelectedCollabId] = useState<string | null>(null);
  const [contractModalOpen, setContractModalOpen] = useState(false);
  const [search, setSearch] = useState('');

  const { data: me } = useGetMe();
  const { data: collaborations = [] } = useListCollaborations<'investor'>();

  const handleOpenContract = (collabId: string) => {
    setSelectedCollabId(collabId);
    setContractModalOpen(true);
  };

  if (!me) {
    return (
      <Box sx={{ p: 3 }}>
        <h2>Cargando...</h2>
      </Box>
    );
  }

  return (
    <Box>
      <PageHeader title="Mis PSIs" />

      <TextField
        fullWidth
        margin="normal"
        label="Buscar por nombre, provincia, ciudad..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <MyPsiCollaborations
        collaborations={collaborations}
        onOpenContract={handleOpenContract}
        searchTerm={search}
      />

      {selectedCollabId && (
        <CollaborationContractModal
          open={contractModalOpen}
          onClose={() => setContractModalOpen(false)}
          collaborationId={selectedCollabId}
          userRole={'investor'}
          hasUserSignature={!!me?.signature?.trim()}
          hasUserSigned={hasUserSigned(
            collaborations.find((c) => c.id === selectedCollabId),
            'investor'
          )}
          bothHaveSigned={bothHaveSigned(collaborations.find((c) => c.id === selectedCollabId))}
        />
      )}
    </Box>
  );
};

export default PsisPage;
